import { render, staticRenderFns } from "./AreaAccountingProductManageDialog.component.vue?vue&type=template&id=3bb2567d"
import script from "./AreaAccountingProductManageDialog.component.vue?vue&type=script&lang=js"
export * from "./AreaAccountingProductManageDialog.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports